import tinymce from "tinymce/tinymce"
tinymce.PluginManager.add("formatpainter", function(editor) {
    // 标记是否激活了格式拷贝模式
    let isActive = false
    let copiedStyles = {}

    editor.ui.registry.addIcon(
        "brushes",
        '<svg t="1614665382680" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1129" width="19" height="19"><path d="M960 448H512v192h32v320a64 64 0 1 1-128 0V640h32v-192a64 64 0 0 1 64-64h448V192h-64V128h64a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64zM64 192H32a32 32 0 1 1 0-64h32V0h832v320H64V192z m64 64h704V64H128v192z" p-id="1130"></path></svg>'
    )

    editor.on("NodeChange", function() {
        if (isActive && copiedStyles) {
            // 应用拷贝的样式到选中的文本
            editor.formatter.apply("copiedStyles", { value: copiedStyles })
            isActive = false // 重置
        }
    })

    // 定义如何拷贝和应用样式的逻辑
    function toggleFormatPainter() {
        if (!isActive) {
            // 拷贝当前选中文本的样式
            const selectedNode = editor.selection.getNode()
            copiedStyles = window.getComputedStyle(selectedNode)

            // 注册自定义格式
            editor.formatter.register("copiedStyles", {
                inline: "span",
                styles: {
                    color: copiedStyles.color,
                    fontSize: copiedStyles.fontSize,
                    fontFamily: copiedStyles.fontFamily,
                    alignContent: copiedStyles.alignContent,
                    background: copiedStyles.background,
                    backgroundColor: copiedStyles.backgroundColor,
                    fontWeight: copiedStyles.fontWeight,
                    textDecoration: copiedStyles.textDecoration
                    // 根据需要添加更多样式
                }
            })

            isActive = true // 激活格式拷贝模式
        } else {
            isActive = false // 如果已激活，则取消激活
        }
    }

    // 添加自定义按钮到工具栏
    editor.ui.registry.addButton("formatpainter", {
        icon: "brushes", // 确保有相应的图标，或者使用文字
        tooltip: "Format Painter",
        onAction: toggleFormatPainter
    })
})
